import React, { useState, useContext, useCallback, useEffect } from "react";
import { Button } from "../../../../components/Button/Button";
import { http } from "../../../../utils/httpCommon";
import { TextInput } from "../../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import useFetchData from "../../../../hooks/FetchData";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Controller } from "react-hook-form";
import LoadingCircle from "../../../../components/LoadingCircle/LoadingCircle";
import ModalComponent from "../../../../components/Modal/Modal2";
import Compnaylogo from "../../../../assets/aiesec.png";
import { toast } from "react-hot-toast";
import { Checkbox } from "@mantine/core";
import { prettyNumber } from "../../../../lib/prettyNumber";
import SelectCurrency from "../../../../components/Currencies/SelectCurrency";
import CalculatedCurrencyAmount from "../../../../components/Currencies/CalculatedCurrencyAmount";

const NewPaymentModal = ({ opened, setOpened, data, fetchData }) => {
  //to do fetch payment method
  // const { selectedLocation } = useContext(SelectedLocationContext);
  // const { response: paymentMethods, loading: loadingPaymentMethod } = useFetchData(`financials/${selectedLocation}/payment-method-accounts`);
  const { response: paymentMethods, loading: loadingPaymentMethod } = useFetchData(
    `rent-contracts/${data?._id}/payment-method-accounts`,
  );

  const [submitLoading, setSubmitLoading] = useState(false);
  const [payWithCredit, setPayWithCredit] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("EGP");

  const paymentMethodValidation = useCallback(() => {
    if (payWithCredit) {
      return yup.string().optional();
    } else {
      return yup
        .number()
        .typeError("Payment method is a required field")
        .required("Payment method is a required field");
    }
  }, [payWithCredit]);

  useEffect(() => {
    paymentMethodValidation();
  }, [payWithCredit]);

  const schema = yup
    .object({
      paymentMethodId: paymentMethodValidation(),
      amount: yup.number().typeError("Amount is required").required("Amount is required"),
      adminPassword: yup
        .string()
        .typeError("Admin password is required")
        .required("Admin password is required"),
      currency: yup.string().required("Currency is required"),
    })
    .required();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (passedData) => {
    setSubmitLoading(true);
    try {
      await http.put(
        `/rent-contracts/${data._id}/pay`,
        payWithCredit
          ? JSON.stringify({
              adminPassword: passedData.adminPassword,
              rentPaymentUsingCredit: payWithCredit,
              paidAmount: passedData.amount,
              currencyId: passedData.currency,
            })
          : JSON.stringify({
              paidAmount: passedData.amount,
              paymentMethodId: Number(passedData.paymentMethodId),
              adminPassword: passedData.adminPassword,
              rentPaymentUsingCredit: payWithCredit,
              currencyId: passedData.currency,
            }),
      );

      toast.success("Successful payment");
      fetchData();
      setOpened(false);
      reset();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || "Something went wrong");
    } finally {
      setSubmitLoading(false);
    }
    // }
  };

  const handleOnClose = () => {
    setOpened(false);
    reset();
  };

  let sum = data?.transactions?.reduce((accumulator, object) => {
    return accumulator + object.amount;
  }, 0);

  const company = data?.company;

  useEffect(() => {
    if (company?.preferredCurrency) {
      setValue("currency", company?.preferredCurrency);
    } else {
      setValue("currency", "");
    }
  }, [company?.preferredCurrency]);

  return (
    <ModalComponent opened={opened} setOpened={setOpened} onClose={handleOnClose} size={"lg"}>
      {!loadingPaymentMethod ? (
        <div className="flex flex-col px-6">
          <div className="text-[24px] mb-2 " style={{ fontFamily: "gilroy-bold" }}>
            New Payment
          </div>

          <div className="border-[1px] rounded-[10px] w-full">
            <div className="flex items-center  ">
              {data?.company?.logo && (
                <img
                  src={data?.company?.logo ? data?.company?.logo : Compnaylogo}
                  alt="Company-logo"
                  className="w-[55px] h-[55px] object-contain "
                />
              )}

              <div className="text-[20px] px-2 py-2" style={{ fontFamily: "gilroy-bold" }}>
                {data?.company?.name}
              </div>
            </div>
          </div>

          <div className="text-[20px] mt-2 text-[#797979] " style={{ fontFamily: "gilroy-bold" }}>
            Contract Number
          </div>
          <div className="text-[24px] font-bold" style={{ fontFamily: "gilroy-bold" }}>
            {data?.rentNumber}
          </div>
          <hr />

          <form className="w-full " onSubmit={handleSubmit(onSubmit)}>
            {!payWithCredit ? (
              <div className="mt-4 mb-2 grid grid-cols-3 gap-2">
                <div className="col-span-2">
                  <FormControl fullWidth sx={{ border: "none !important" }}>
                    <InputLabel>Payment Method</InputLabel>
                    <Controller
                      control={control}
                      name="paymentMethodId"
                      render={({ field: { onChange, onBlur, value, name, ref } }) => (
                        <Select
                          sx={{
                            color: "black",
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "#EFEFEF",
                            },
                          }}
                          onBlur={onBlur}
                          onChange={onChange}
                          variant="outlined"
                          labelId="Payment Method-label"
                          id="Payment Method"
                          value={value}
                          label="Payment Method"
                          inputRef={ref}
                          defaultValue=""
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {paymentMethods?.map((l) => {
                            return (
                              l?.name.toLowerCase() != "receivable" && (
                                <MenuItem key={l?.qboId} value={l?.qboId}>
                                  {l?.name}
                                </MenuItem>
                              )
                            );
                          })}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="text-red-500">{errors.paymentMethodId?.message}</p>
                </div>
                <div className="col-span-1">
                  <FormControl fullWidth sx={{ border: "none !important" }}>
                    <InputLabel>Currency</InputLabel>
                    <Controller
                      control={control}
                      defaultValue={company?.preferredCurrency || ""}
                      name="currency"
                      render={({ field: { onChange, value, defaultValue } }) => (
                        <SelectCurrency
                          value={value}
                          onChange={onChange}
                          defaultValue={defaultValue}
                          preferredCurrency={company?.preferredCurrency}
                        />
                      )}
                    />
                  </FormControl>

                  <p className="text-red-500">{errors.currency?.message}</p>
                </div>
              </div>
            ) : null}
            <div className="flex flex-col w-full gap-2 bg-[#f4f5f5] p-4 my-4 rounded-[10px]">
              <div className="flex justify-between">
                <div className="flex flex-col">
                  <span className="text-[16px] font-bold">Total Due</span>
                  <span
                    className="text-[20px] flex items-center gap-2 "
                    style={{ fontFamily: "gilroy-bold" }}
                  >
                    {prettyNumber(data?.total - sum)} EGP
                    <CalculatedCurrencyAmount
                      amount={data?.total - sum}
                      toCurrency={watch("currency")}
                      setCurrencySymbol={setCurrencySymbol}
                    />
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-[16px] font-bold">Amount Paid</span>
                  <span
                    className="text-[20px] text-[#797979]"
                    style={{ fontFamily: "gilroy-bold" }}
                  >
                    {prettyNumber(sum)} EGP
                  </span>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-4">
              <Checkbox
                label="Pay with credit"
                checked={payWithCredit}
                onChange={(event) => {
                  setPayWithCredit(event.currentTarget.checked);
                }}
                color="rgba(0, 0, 0, 1)"
                size={"md"}
              />
            </div>

            <div className="mt-4 ">
              <TextInput
                height="40px"
                label={`Amount Paid in (${currencySymbol})`}
                type="number"
                defaultValue={0}
                {...register("amount")}
              />
              <p className="text-red-500 mt-4">{errors.amount?.message}</p>
            </div>

            <div className="mt-10 ">
              <TextInput
                height="40px"
                type="password"
                label={`Admin Password`}
                {...register("adminPassword")}
              />
              <p className="text-red-500 mt-4 ">{errors.adminPassword?.message}</p>
            </div>

            <div className="mt-6 mb-20 flex justify-end gap-10">
              <Button
                onClick={() => setOpened(false)}
                secondary={true}
                disabled={submitLoading}
                invert={true}
              >
                Cancel
              </Button>
              <Button loading={submitLoading} type="submit" secondary={true}>
                Pay now
              </Button>
            </div>
          </form>
        </div>
      ) : (
        <LoadingCircle />
      )}
    </ModalComponent>
  );
};

export default NewPaymentModal;
